import React from "react";
import { GoogleLogout } from "react-google-login";

interface Props {
    logoutSuccess: () => void;
}

export class GoogleSignOut extends React.PureComponent<Props> {
    public render() {
        return <div className={"signout-button"}>
            <GoogleLogout
                clientId={`${process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID}`}
                buttonText={"Logout"}
                onLogoutSuccess={this.props.logoutSuccess}
            />
        </div>;
    }
}
